import { CSSObject } from '@emotion/react';

export const getSupportHeaderActionsStyles = (): CSSObject => ({
    display: 'inline-flex',
    flexDirection: 'column',
});
